import { render, staticRenderFns } from "./ChallengeProductModal.vue?vue&type=template&id=77994560"
import script from "./ChallengeProductModal.vue?vue&type=script&lang=js"
export * from "./ChallengeProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports